export default "__VITE_ASSET__aghopCh7__ 800w";